import React from "react";
import { useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import { MultiSelect } from "@/components/fields/multi-select";

export function ReferenceIdsField({ id, inputProps }: AutoFormFieldProps) {
  const value: string[] = useWatch({ name: id }) ?? [];
  const ticketing = useWatch({ name: "ticketing" });
  const tickets = useWatch({ name: "tickets" });

  if (!ticketing) return null;

  const options = [
    { label: "All", value: "all" },
    ...(ticketing?.groups?.map((g: any) => ({
      label: g.name,
      value: g.id,
    })) ?? []),
    ...(tickets
      ?.filter((t: any) => !t.dummy)
      .map((t: any) => ({
        label: t.name,
        value: t.id,
      })) ?? []),
  ];

  return (
    <div className="flex flex-col space-y-2 text-foreground w-full">
      <MultiSelect
        options={options}
        selected={value}
        // disabled={inputProps?.disabled}
        onChange={(selected) => {
          const next =
            selected.includes("all") || selected.length === 0 ? null : selected;
          inputProps.onChange({
            target: { name: id, value: next },
          } as unknown as React.ChangeEvent<HTMLInputElement>);
        }}
        placeholder="Select which tickets are included in the discount..."
      />
    </div>
  );
}
